<template>
  <div>

    <!-- comments -->
    <b-row v-for="comment in comments" :key="comment.id" class="comment-row">
      <b-col>
        <div class="text-muted">
          <em>
            <small>{{ dateFormat(comment.createdAt) }} | <b-link class="text-danger" @click="deleteComment(comment.id)">удалить</b-link></small>
          </em>
        </div>
        <template>
          <div class="text-muted" v-if="comment.type === 'auto'">
            <em v-html="nl2br(comment.content)"></em>
          </div>
          <div v-else-if="comment.type === 'sipuni'">
            <em v-html="getCaller(comment.content)"></em><br>
            <audio :src="getAudioSrc(comment.content)" controls></audio>
          </div>
          <div v-else v-html="nl2br(comment.content)">
          </div>
        </template>
      </b-col>
    </b-row>

    <!-- form -->
    <b-card no-body>
      <b-tabs pills card small>
        <b-tab title="Комментарий" active>
          <b-card-text>
            <b-form @submit="onSubmit">
              <b-form-group>
                <b-form-textarea
                  id="textarea"
                  v-model="form.text"
                  placeholder="Комментарий..."
                  rows="3"
                  max-rows="6"
                ></b-form-textarea>
              </b-form-group>
              <b-row>
                <b-col cols="auto">
                  <loading-button type="submit" text="Сохранить" :is-busy="addBusy"></loading-button>
                </b-col>
                <b-col cols="6">
                  <b-alert v-model="error" dismissible variant="danger">{{ message }}</b-alert>
                </b-col>
              </b-row>
            </b-form>
          </b-card-text>
        </b-tab>
        <b-tab title="Задача">
          <b-card-text>
            <b-form @submit="createTask" size="sm">
              <b-form-group label="Задача:" label-cols-sm="3" label-cols-lg="3">
                <b-textarea v-model="form.content" rows="3" max-rows="6"></b-textarea>
              </b-form-group>
              <b-form-group label="Статус:" label-cols-sm="3" label-cols-lg="3">
                <b-form-select v-model="form.status" required :options="statusOptions"></b-form-select>
              </b-form-group>
              <b-form-group label="Ответственный:" label-cols-sm="3" label-cols-lg="3">
                <multi-select
                  v-model="form.responsible"
                  :options="optionsResponsible"
                  :searchable="true"
                  :loading="isLoadingResponsible"
                  :internal-search="false"
                  :hide-selected="true"
                  track-by="last_name"
                  label="last_name"
                  placeholder="Введите имя для поиска"
                  selectLabel="Enter чтобы выбрать"
                  @search-change="asyncFindResponsible"
                >
                  <template slot="option" slot-scope="props">{{ contactFullName(props.option) }}</template>
                  <template slot="noOptions">Начните вводить имя</template>
                  <template slot="singleLabel" slot-scope="{ option }">{{ contactFullName(option) }}</template>
                  <span slot="noResult">Не найдено</span>
                </multi-select>
              </b-form-group>

              <b-form-group label="Выполнить:" label-cols-sm="3" label-cols-lg="3">
                <b-form-row>
                  <b-col>
                    <b-form-input
                      v-model="dueDateTime"
                      type="datetime-local"
                    ></b-form-input>
                    <div class="float-left">
                      <small>
                        <a class="link" @click="setDate('today')">Сегодня</a> |
                        <a class="link" @click="setDate('tomorrow')">Завтра</a> |
                        <a class="link" @click="setDate('week')">Неделя</a> |
                        <a class="link" @click="setDate('month')">Месяц</a> |
                        <a class="link" @click="setDate('year')">Год</a>
                      </small>
                    </div>
                    <div class="float-right">
                      <small>
                        <span>через </span>
                        <a class="link" @click="setTime('1h')">час</a> |
                        <a class="link" @click="setTime('2h')">2ч</a> |
                        <a class="link" @click="setTime('3h')">3ч</a> |
                        <a class="link" @click="setTime('fullday')">весь день</a>
                      </small>
                    </div>
                  </b-col>
                </b-form-row>
              </b-form-group>

              <b-alert v-model="error" dismissible variant="danger">{{ message }}</b-alert>
              <loading-button :is-busy="addBusy" :text="'Создать'"></loading-button>
            </b-form>
          </b-card-text>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import LoadingButton from "./LoadingButton";
import MultiSelect from 'vue-multiselect';
import commonMixin from '../mixins/common';
import moment from 'moment';

export default {
  name: "Comments",
  mixins: [commonMixin],
  components: {LoadingButton, MultiSelect},
  props: {
    entity: Object,
    entityType: String
  },
  data() {
    return {
      form: {
        text: '',
        content: '',
        status: 'todo',
        due_date: ''
      },
      comments: [],
      isLoadingResponsible: false,
      optionsResponsible: [],
      addBusy: false,
      loadBusy: false,
      error: false,
      statusOptions: [
        {value: 'todo', text: 'К выполнению'},
        {value: 'done', text: 'Готово'},
      ],
      message: '',
    }
  },
  mounted() {
    this.comments = [];
    this.setDate('today');
  },
  computed: {
    dueDateTime: {
      get: function () {
        return this.form.due_date ? moment(this.form.due_date).format('YYYY-MM-DD[T]HH:mm') : ''
      },
      set: function (value) {
        this.form.due_date = moment(value).toISOString()
      }
    },
  },
  methods: {
    createTask(evt) {
      evt.preventDefault();
      this.error = false;
      this.addBusy = true;
      let promise = null;

      promise = this.axios.put(process.env.VUE_APP_BACKEND_URL + '/api/tasks/', JSON.stringify(this.form));

      return promise.then((response) => {
        this.addBusy = false;
        if (response) {
          if (response.data.error === false) {
            this.error = false;
            this.fetchComments();
          } else {
            this.error = true;
            this.message = response.data.message;
          }
        }
      })
    },
    nl2br(str) {
      return str.replace(/([^>])\n/g, '$1<br/>');
    },
    onSubmit(evt) {
      evt.preventDefault();
      this.addBusy = true;
      this.error = false;
      this.axios.put(process.env.VUE_APP_BACKEND_URL + '/api/comments/', {
        text: this.form.text,
        entity_type: this.entityType,
        entity_id: this.entity.id
      })
        .then(response => {
          this.addBusy = false;
          if (!response.data.error) {
            this.comments.unshift(response.data.comment);
            this.error = false;
            this.form.text = '';
            return this.comments || []
          } else {
            this.error = true;
            this.message = response.data.message;
          }
        })
        .catch((error) => {
          console.log(error);
          this.addBusy = false;
          this.comments = [];
          return this.comments || []
        });
    },
    asyncFindResponsible(query) {
      this.isLoadingResponsible = true
      const promise = this.axios.get(process.env.VUE_APP_BACKEND_URL + '/api/users/?query=' + query);
      return promise.then(response => {
        this.optionsResponsible = response.data.users;
        this.isLoadingResponsible = false;
      }).catch((error) => {
        console.log(error);
        this.optionsResponsible = [];
        this.isLoadingResponsible = false;
      });
    },
    fetchComments() {
      if (!(this.entity.id && this.entityType)) {
        return;
      }
      this.loadBusy = true;
      this.axios.get(process.env.VUE_APP_BACKEND_URL + '/api/comments/?entity=' + this.entityType + '&entity_id=' + this.entity.id)
        .then(response => {
          this.comments = response.data.comments;
          this.loadBusy = false;
          return this.comments || []
        })
        .catch((error) => {
          console.log(error);
          this.loadBusy = false;
          this.comments = [];
          return this.comments || []
        });
    },
    dateFormat(dt) {
      const date = new Date(dt);
      const dateTimeFormat = new Intl.DateTimeFormat('ru', {
        year: 'numeric', month: '2-digit',
        day: '2-digit', hour: '2-digit', minute: '2-digit'
      });
      const [{value: day}, , {value: month}, , {value: year}, , {value: hour}, , {value: minute}] = dateTimeFormat.formatToParts(date);
      return day + "." + month + "." + year + " " + hour + ":" + minute;
    },
    getAudioSrc(content) {
      //console.log(content)
      const object = JSON.parse(content);
      return process.env.VUE_APP_BACKEND_URL + '/api/sipuni/record/' + object.callId;
    },
    getCaller(content) {
      const object = JSON.parse(content);
      return "Звонок - " + object.caller;
    },
    setTime(value) {
      if (value === 'fullday') {
        this.dueDateTime = moment(this.form.due_date).format('YYYY-MM-DD[T23:59]');
      } else if (value === '1h') {
        this.dueDateTime = moment().add(1, 'hours').format('YYYY-MM-DD[T]HH:mm');
      } else if (value === '2h') {
        this.dueDateTime = moment().add(2, 'hours').format('YYYY-MM-DD[T]HH:mm');
      } else if (value === '3h') {
        this.dueDateTime = moment().add(3, 'hours').format('YYYY-MM-DD[T]HH:mm');
      }
    },
    setDate(value) {
      if (value === 'today') {
        this.dueDateTime = moment().format('YYYY-MM-DD[T23:59]');
      } else if (value === 'tomorrow') {
        this.dueDateTime = moment().add(1, 'days').format('YYYY-MM-DD[T23:59]');
      } else if (value === 'week') {
        this.dueDateTime = moment().add(7, 'days').format('YYYY-MM-DD[T23:59]');
      } else if (value === 'month') {
        this.dueDateTime = moment().add(1, 'months').format('YYYY-MM-DD[T23:59]');
      } else if (value === 'year') {
        this.dueDateTime = moment().add(1, 'years').format('YYYY-MM-DD[T23:59]');
      }
    },
    deleteComment(id) {
      if(confirm('Удалить комментарий?')){
        this.axios.delete(process.env.VUE_APP_BACKEND_URL + '/api/comments/' + id)
          .then(() => {
            this.fetchComments()
          })
          .catch((error) => {
            console.log(error)
          });
      }
    }
  },
  watch: {
    "entity": {
      handler: function (data) {
        if (data) {
          this.fetchComments();
          this.form.source = this.entityType;
          if (this.entityType === "contact") {
            this.form.contact = data;
          }
          if (this.entityType === "deal") {
            this.form.deal = data;
          }
          if (this.entityType === "company") {
            this.form.company = data;
          }
        }
      },
      immediate: true,
      deep: false
    },
  },

}
</script>

<style scoped lang="scss">
.comment-row {
  margin-top: 10px;
  margin-bottom: 10px;
}
.link {
  cursor: pointer;
}
</style>
